import React from 'react';
import { Flex, Box } from 'theme-ui';
import ContentText from '@solid-ui-components/ContentText';
import Icon from '@solid-ui-components/ContentIcon';
import styles from './styles';

const ListItem = ({
  icon,
  iconProps,
  text,
  left,
  vertical,
  center,
  middle, //Centering for horizontal layout,
  iconStyles,
  size = 'sm',
  wrapperStyles,
}) => (
  <Flex
    sx={{
      ...styles.wrapper,
      flexDirection: vertical ? 'column' : 'row',
      alignItems: center ? 'center' : 'flex-start',
      textAlign: left
        ? [null, 'center', null, null, 'left']
        : center && vertical
        ? 'center'
        : 'unset',
      justifyContent: middle ? 'center' : 'unset',
      ...wrapperStyles,
    }}
  >
    {icon?.src && (
      <Box sx={{ ...styles.iconWrapper, ...iconStyles }}>
        <Icon content={icon} size={size} {...iconProps} />
      </Box>
    )}
    <Box sx={{ alignSelf: vertical ? 'auto' : 'center' }}>
      <ContentText content={text} />
    </Box>
  </Flex>
);

ListItem.defaultProps = {
  iconProps: {},
};

export default ListItem;
